import { Link } from 'react-router-dom';
import { Fragment } from 'react';

export type Crumb = { label: string; to?: string; icon?: string };

export function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav aria-label="breadcrumb">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-slate-500">
        {crumbs.map((c, i) => (
          <Fragment key={i}>
            {i > 0 && <span className="material-symbols-outlined text-slate-300" style={{ fontSize: '14px' }}>chevron_right</span>}
            <li>
              {c.to ? (
                <Link to={c.to} className="inline-flex items-center gap-1 text-primary hover:underline">
                  {c.icon && <span className="material-symbols-outlined" style={{ fontSize: '15px' }}>{c.icon}</span>}
                  <span style={{ fontSize: '13px' }}>{c.label}</span>
                </Link>
              ) : (
                <span className="inline-flex items-center gap-1 text-slate-700 font-semibold">
                  {c.icon && <span className="material-symbols-outlined" style={{ fontSize: '15px' }}>{c.icon}</span>}
                  <span style={{ fontSize: '13px' }}>{c.label}</span>
                </span>
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
}
